<template>
    <sa-page-layout :btnRefreshVisible="true" :showModalLoading="showModalLoading">
        <template slot="toolbar">
            <b-button size="sm" @click="onClickNuovoDbCompare" variant="success btn-toolbar" class="float-sm-right"> <b-icon icon="plus"></b-icon> Nuovo </b-button>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">DB Struttura</label>
                        <b-form-select v-model="filtroDbCompare.dbStruttura">
                            <template #first>
                                <b-form-select-option :value="null"> - Seleziona un tipo - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">DB Hl7</label>
                        <b-form-select v-model="filtroDbCompare.dbHl7">
                            <template #first>
                                <b-form-select-option :value="null"> - Seleziona un tipo - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">DB Thcs</label>
                        <b-form-select v-model="filtroDbCompare.dbthcs">
                            <template #first>
                                <b-form-select-option :value="null"> - Seleziona un tipo - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info"> Cerca </b-button>
                        <b-button type="reset" variant="danger"> Reset filtri </b-button>
                        <!--  v-on:click="onReset" -->
                    </b-col>
                </b-row>
            </b-form>
        </template>

        <template slot="table-body">
            <db-compare-list-component ref="cmpDbCompareList" @afterLoadData="onAfterLoadData" @beforeLoadData="onBeforeLoadData" />
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import DbCompareListComponent from "../components/dbCompareListComponent.vue";
export default {
    components: { SaPageLayout, DbCompareListComponent },
    data() {
        return {
            showModalLoading: false,
            filtroDbCompare: {},
        };
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.$refs.cmpDbCompareList.loadData();
        },

        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onClickNuovoDbCompare() {
            let me = this;
            me.$refs.cmpDbCompareList.nuovoDbCompare();
        },
    },
};
</script>
